export const getBreakLineCharacter = () => {
  const isMobile = !!window.ReactNativeWebView;

  if (isMobile) {
    return '\n';
  }
  return '%0D%0A';
};
